import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ToggleService } from '../../template-components/header/toggle.service';
import { UserSessionService } from '../../ui-framework/global-services/user-session/user-session.service';

@Component({
    selector: 'app-logout',
    imports: [RouterLink],
    templateUrl: './logout.component.html',
    styleUrl: './logout.component.scss'
})
export class LogoutComponent {

    constructor(
        public toggleService: ToggleService,
        private readonly userSession: UserSessionService
    ) {}

    ngOnInit(): void {
        // Initialize theme and direction on component load
        this.toggleService.initializeTheme();
        this.userSession.logoutSession();
    }

    // Toggle theme between light and dark
    toggleTheme() {
        this.toggleService.toggleTheme();
    }

    // Toggle direction between LTR and RTL
    toggleDirection() {
        this.toggleService.toggleDirection();
    }

}
